import { useEffect } from 'react';
import { IBlockData } from '@bay-email/core';
import { useEditorContext, useFocusIdx } from '@bay-email/editor';
import { hasAttachedListing } from './listingAttachment';

/**
 * Clears a block's attached listing (selectedListing / selectedListingId) once
 * the block no longer uses any listing merge tags. Without this the attachment
 * persists invisibly, and shouldShowListingMergeTagsForBlock keeps offering
 * listing options even though the user removed every listing dynamic field.
 *
 * Safe against loops: once cleared, hasAttachedListing becomes false and the
 * effect no-ops.
 */
export function useClearAttachedListingWhenUnused(
	block: IBlockData | null | undefined,
	hasListingMergeTags: boolean,
) {
	const { focusIdx } = useFocusIdx();
	const { formHelpers } = useEditorContext();
	const hasAttached = hasAttachedListing(block);

	useEffect(() => {
		if (hasListingMergeTags || !hasAttached || !focusIdx) return;
		formHelpers.change(`${focusIdx}.data.value.selectedListingId`, '');
		formHelpers.change(`${focusIdx}.data.value.selectedListing`, null);
	}, [hasListingMergeTags, hasAttached, focusIdx, formHelpers]);
}
